import React from 'react';
import {
  Button,
  FormInputText,
  Icon,
  P,
} from '@fashionnovateam/nova-ui-toolkit';

export type Verify2FACodeProps = {
  loading: boolean;
  sentTo: string;
  isInfluencer: boolean;
  verify: (code: string) => void;
};

export function Verify2FACode(props: Verify2FACodeProps) {
  const { loading, sentTo, isInfluencer, verify } = props;
  const [errors, setErrors] = React.useState<{ code?: string }>({});

  const validateCode = (code: string) => {
    if (code.length === 0) {
      setErrors((prev) => ({
        ...prev,
        code: 'Please enter a code.',
      }));
      return false;
    }
    setErrors((prev) => ({
      ...prev,
      code: undefined,
    }));
    return true;
  };

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    const form = event.currentTarget as HTMLFormElement;
    const code = form.code.value;
    if (!validateCode(code)) {
      return;
    }
    verify(code);
  };

  const handleAccessCodeBlur = (code: string) => {
    validateCode(code);
  };

  return (
    <div className="flex flex-col gap-6">
      <form className="flex flex-col gap-10" onSubmit={handleSubmit}>
        <div className="flex flex-col gap-4">
          <P size="xl" weight="medium">
            Enter your one-time verification code
          </P>
          <P size="sm" weight="normal" color="disabled">
            We have sent a one-time code to{' '}
            <span className="font-semibold">{sentTo}</span>. The code expires
            shortly, so please enter it soon.
          </P>
          <FormInputText
            label="Access Code"
            name="code"
            inputId="code"
            disabled={loading}
            error={errors.code}
            onBlurValue={handleAccessCodeBlur}
          />
        </div>
        <Button className="w-full" type="submit" loading={loading}>
          Continue
          <Icon.ArrowRight />
        </Button>
      </form>
      <P size="xs" weight="normal" color="disabled">
        If you do not see the code within a few minutes, check your spam. If you
        continue having trouble, please{' '}
        <a
          href={`mailto:${
            isInfluencer
              ? 'influencerdocs@fashionnova.com'
              : 'vendormasterdata@fashionnova.com'
          }`}
          className="underline"
        >
          email support
        </a>
        .
      </P>
    </div>
  );
}
